/**
 * 404 Not Found (W1a / RT-10).
 *
 * The router previously sent every unmatched path to `/` via a silent catch-all,
 * which meant a route accidentally dropped in a merge would land the user on the
 * Overview with no signal that anything was wrong. A real NotFound page makes a
 * missing/broken route visible instead of masking it, and the route-manifest
 * test asserts every sidebar link still resolves to a real component.
 */
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Compass, Home } from 'lucide-react';

const NotFound: React.FC = () => {
  const location = useLocation();
  return (
    <div className="flex items-center justify-center py-24">
      <div className="text-center max-w-md">
        <div className="mx-auto mb-5 w-16 h-16 rounded-2xl bg-iflow-100 flex items-center justify-center">
          <Compass className="w-8 h-8 text-iflow-700" />
        </div>
        <h1 className="text-2xl font-bold text-iflow-900">Page not found</h1>
        <p className="mt-2 text-sm text-gray-500">
          No page is mapped to <span className="font-mono text-iflow-800">{location.pathname}</span>.
          It may have moved, or the link may be out of date.
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-iflow-600 text-white text-sm font-medium hover:bg-iflow-700 transition-colors"
        >
          <Home className="w-4 h-4" /> Back to Overview
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
